module.exports = __webpack_public_path__ + "static/media/individual_dynamo.c3e29cbd.svg";